import { IGridSettings, IImageSettings, Image, RichTextComponent } from '@msdyn365-commerce/core';
import * as React from 'react';
import { IWineClub } from '../../../settings/app.settings';
import { WineClubDataStore } from '../wine-club-data';
import { IWineClubSignupConfig, IWineClubSignupResources } from '../wine-club-signup.props.autogenerated';

export interface IVariant {
    clubInfo: IWineClub[];
    config: IWineClubSignupConfig;
    resources: IWineClubSignupResources;
    gridSettings: IGridSettings;
    imageSettings?: IImageSettings;
}

export interface IVariantState {
    buttonState: boolean;
}

/**
 * renders the currently selected variant
 */
export class Variant extends React.Component<IVariant, IVariantState> {

    private _dataStore: WineClubDataStore;

    constructor(props: IVariant) {
        super(props);

        this._toggleMobileState = this._toggleMobileState.bind(this);

        this._dataStore = WineClubDataStore.getInstance();

        this.state = {
            buttonState: props.config.openByDefault || false
        };
    }

    public render(): JSX.Element {
        const store = this._dataStore.get();

        if (store.clubId === null || store.variantPreference === null) {
            return <div />; // for safety
        }

        const club = this.props.clubInfo[store.clubId] || [];
        const variants = club.variants || [];
        const variant = variants.find(clubVariant => clubVariant.winePreference === store.variantPreference);

        if (!variant) { return <div />; }

        let mobileButtonText = this.props.resources.wineClubSignup__variantMembershipMobileClose;
        let mobile = 'closed';
        if (this.state.buttonState) {
            mobileButtonText = this.props.resources.wineClubSignup__variantMembershipMobileOpen;
            mobile = 'open';
        }

        return (
            <div className='wine-club-signup-variant'>
                <h2 className='wine-club-signup-variant-title'>{this.props.config.reviewBenefits?.title || this.props.resources.wineClubSignup__stepThree}</h2>
                {this.props.config.reviewBenefits?.subtitle && <RichTextComponent className='wine-club-signup-variant-subtitle' text={this.props.config.reviewBenefits.subtitle} />}
                {this.props.config.showDetailsToggle && <button
                    className={`wine-club-signup-variant-expand-button ${mobile}`}
                    onClick={this._toggleMobileState}
                >
                    {mobileButtonText}
                </button>}
                <div className={`wine-club-signup-variant-info-container ${mobile}`}>
                    <div className='wine-club-signup-variant-image'>
                        <Image {...variant.wineImage} imageSettings={this.props.imageSettings} gridSettings={this.props.gridSettings} />
                    </div>
                    <div className='wine-club-signup-variant-info'>
                        <h4 className='wine-club-signup-variant-info-title'>{this.props.resources.wineClubSignup__variantMembershipSub}</h4>
                        <h2 className='wine-club-signup-variant-info-subtitle'>{club.title}</h2>
                        <div className='wine-club-signup-variant-info-description'>
                            <RichTextComponent text={variant.description} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private _toggleMobileState(): void {
        this.setState({
            buttonState: !this.state.buttonState
        });
    }
}